// extracted by mini-css-extract-plugin
module.exports = {"break1":"Header_break1__28qk0","break2":"Header_break2__3n-n5"};